import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../hooks/useFavorites';
import EmptyFavorites from '../components/favorites/EmptyFavorites';
import FavoritesList from '../components/favorites/FavoritesList';
import AuthMessage from '../components/favorites/AuthMessage';
import { Recipe } from '../types/recipe';
import ScrollToTopButton from '../components/common/ScrollToTopButton';

type Props = {
  onRecipeSelect: (recipe: Recipe) => void;
  onNavigate: (page: 'home' | 'favorites' | 'profile') => void;
};

export default function FavoritesPage({ onRecipeSelect, onNavigate }: Props) {
  const { user } = useAuth();
  const { favorites } = useFavorites();

  const handleRecipeSelect = (recipe: Recipe) => {
    // Save scroll position before navigating
    const scrollPosition = window.scrollY;
    sessionStorage.setItem('favoritesScrollPosition', scrollPosition.toString());
    onRecipeSelect(recipe);
  };

  // Restore scroll position when component mounts
  React.useEffect(() => {
    const savedPosition = sessionStorage.getItem('favoritesScrollPosition');
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedPosition));
        sessionStorage.removeItem('favoritesScrollPosition');
      }, 0);
    }
  }, []);

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 pb-16 px-4 py-6">
        <div className="flex items-center mb-6">
          <button
            onClick={() => onNavigate('home')}
            className="flex items-center text-gray-600 hover:text-gray-900 mr-4"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Retour
          </button>
          <h1 className="text-2xl font-bold">Mes Favoris</h1>
        </div>
        <AuthMessage onNavigateToProfile={() => onNavigate('profile')} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-16 px-4 py-6">
      <div className="flex items-center mb-6">
        <button
          onClick={() => onNavigate('home')}
          className="flex items-center text-gray-600 hover:text-gray-900 mr-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Retour
        </button>
        <h1 className="text-2xl font-bold">Mes Favoris</h1>
      </div>
      
      {favorites.length === 0 ? (
        <EmptyFavorites />
      ) : (
        <FavoritesList 
          recipes={favorites}
          onRecipeSelect={handleRecipeSelect}
        />
      )}
      <ScrollToTopButton />
    </div>
  );
}